import React from 'react';
import { Link } from 'react-router-dom';
import { FaHome, FaExclamationTriangle } from 'react-icons/fa';
import './PageNotFound.css';

const PageNotFound = () => {
  return (
    <section className="page-not-found-section">
      <div className="page-not-found-container">
        
        {/* Animated Background Text */}
        <div className="page-not-found-bg-text">404</div>

        {/* Main Content */}
        <div className="page-not-found-content">
          <div className="page-not-found-icon-wrapper">
            <FaExclamationTriangle className="page-not-found-icon" />
          </div>
          
          <h1 className="page-not-found-title">Page Not Found</h1>
          
          <p className="page-not-found-description">
            Oops! It looks like you've taken a wrong turn. 
            The page you are looking for might have been removed, 
            had its name changed, or is temporarily unavailable.
          </p>

          <Link to="/" className="page-not-found-btn">
            <FaHome className="btn-icon" />
            Back to Home
          </Link>
        </div>

      </div>
    </section>
  );
};

export default PageNotFound;